module.exports = __webpack_public_path__ + "static/ELON-a561ba4d73dbb028477397b0f91a420b.svg";